import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";

const SmallHeader = (
  {
    title
  }
) => (
  <div className="small-header">
    <div className="hero">
      <div className="hero__headline">{title}</div>
    </div>
  </div>
);

SmallHeader.propTypes = {
  title: PropTypes.string
};

export default SmallHeader;



// WEBPACK FOOTER //
// ./src/components/SmallHeader.js